import React, { useEffect, useState } from 'react';
import { getTrackBackground, Range } from 'react-range';

// Types
import { FilterItem } from '@src/types/search';

const PriceRange = ({ filter }: { filter: FilterItem }) => {
  const { label, values } = filter;
  const filterData = JSON.parse(values[0].input);
  const { price } = filterData;
  const min = price.min;
  const max = price.max;

  const [range, setRange] = useState<[number, number]>([min, max]);
  const [minMax, setMinMax] = useState<[number, number] | null>(null);

  const handleUpdateFilter = (values: number[]) => {
    if (!values) return;

    const input = JSON.stringify({
      price: {
        min: values[0],
        max: values[1]
      }
    });

    const filterEvent = new CustomEvent('searchrequest-filter-applied', {
      detail: {
        input,
        type: 'header-search',
        filterType: 'price_range'
      }
    });

    window.dispatchEvent(filterEvent);
  };

  const handleSearchStateChange = (event: Event) => {
    const { hasResults, query }: { hasResults: boolean; query: string } = (event as CustomEvent).detail || {};

    if (!hasResults && !query) {
      setMinMax(null);
    }
  };

  useEffect(() => {
    if (minMax) return;

    setMinMax([min, max]);
  }, [filter]);

  useEffect(() => {
    // Listen for filters data from search results
    window.addEventListener('search-state-changed', handleSearchStateChange);

    return () => {
      window.removeEventListener('search-state-changed', handleSearchStateChange);
    };
  }, []);

  if (!range || !minMax) return null;

  return (
    <div>
      <p className='b6--bold mb-4'>{label}</p>

      <Range
        step={1}
        min={minMax[0]}
        max={minMax[1]}
        values={range}
        onChange={(values) => setRange(values)}
        onFinalChange={(values) => handleUpdateFilter(values)}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: '13px',
              display: 'flex',
              width: '100%'
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: '2px',
                width: '100%',
                borderRadius: '24px',
                background: getTrackBackground({
                  values: range,
                  colors: ['#DEDEDE', '#000000', '#DEDEDE'],
                  min: minMax[0],
                  max: minMax[1]
                }),
                alignSelf: 'center'
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, isDragged }) => (
          <div
            {...props}
            key={props.key}
            style={{
              ...props.style,
              height: '12px',
              width: '12px',
              borderRadius: '9999px',
              backgroundColor: '#ffffff',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: '1px solid #000000'
            }}
          ></div>
        )}
      ></Range>
      <div className='flex justify-between mt-3'>
        <span>${min}</span>
        <span>${max}</span>
      </div>
    </div>
  );
};

export default PriceRange;
